import {TeamMember} from "../../models/work-items/team-member.model";

export interface TeamMembersResponse {
  total: number;
  teamMembers: TeamMember[];
}
